<ng-container *ngIf="(show$ | async)">
    <mat-progress-bar
        [mode]="(mode$ | async)"
        [value]="(progress$ | async)"></mat-progress-bar>
</ng-container>
